import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=50886847&scoped=true&"
import script from "./Page4.vue?vue&type=script&lang=ts&"
export * from "./Page4.vue?vue&type=script&lang=ts&"
import style0 from "./Page4.vue?vue&type=style&index=0&id=50886847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50886847",
  null
  
)

export default component.exports